import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import PageHero from "@/components/feature/PageHero";
import SectionTitle from "@/components/base/SectionTitle";
import { services } from "@/mocks/services";

export default function Services() {
  return (
    <Layout>
      <PageHero
        eyebrow="Services Detail"
        title="サービス詳細"
        description="マンションの共用部日常清掃を軸に、オーナー様の運用を軽くする周辺サービスまで。全て自社スタッフが直接対応します。"
        image="images/service-detail.avif"
      />

      <section className="bg-background-50 py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-4 md:px-10">
          <SectionTitle
            eyebrow="Services"
            title="サービス詳細"
            description="各サービスの詳細です。気になりましたら気軽にお問い合わせください。"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-7">
            {services.map((s) => (
              <div
                key={s.slug}
                className="bg-background-100 rounded-lg border border-background-200 overflow-hidden flex flex-col"
              >
                <div className="relative h-48">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-500 text-background-50 mb-4">
                    <i className={`${s.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading text-lg text-foreground-950 mb-2">{s.title}</h3>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4 text-justify">{s.subtitle}</p>
                  <ul className="space-y-1.5 text-sm text-foreground-800 mb-4">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-start gap-2">
                        <i className="ri-check-line text-primary-600 mt-0.5"></i>
                        <span>{f}</span>
                      </li>
                    ))}
                  </ul>
                  <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-4">
                    <span className="text-primary-700 font-heading text-base">{s.price}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-20 md:py-28">
        <div className="mx-auto max-w-6xl px-4 md:px-10">
          <SectionTitle
            eyebrow="Flow"
            title="ご依頼の流れ"
            description="ご相談から施工開始まで、最短5日。しつこい営業や不透明な追加費用は一切ございません。"
          />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            {[
              { step: "01", title: "お問い合わせ", text: "フォーム・お電話でご相談ください。ヒアリング約15分。" },
              { step: "02", title: "現地確認・見積", text: "24時間以内に日程調整。現地確認とお見積は無料です。" },
              { step: "03", title: "ご契約", text: "内容にご納得いただいてから、書面にてご契約。" },
              { step: "04", title: "作業開始・レポート", text: "作業前後の写真報告と月次レポートで、継続的に見える化。" },
            ].map((f) => (
              <div key={f.step} className="bg-background-50 rounded-lg border border-background-200 p-6">
                <div className="font-heading text-3xl text-accent-600 mb-3">{f.step}</div>
                <h3 className="font-heading text-lg text-foreground-950 mb-2">{f.title}</h3>
                <p className="text-sm text-foreground-700 leading-relaxed text-justify">{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}